import styled from 'styled-components';
import { applyStyleModifiers } from 'styled-components-modifiers';

import { position, media } from '../../core';

const modifiers = {
  slideUp: () => ({
    styles: `
      opacity: 1;
      transform: translate(0, 0);
    `,
  }),
  menuBehavior: () => ({
    styles: `
      position: absolute;
      bottom: 0;
    `,
  }),
  headerSmall: () => ({
    styles: `
      @media ${media.tabletMax} {
        top: -6rem;
        .component__mainHeader {
          padding: 0;
        }        
      }
    `,
  }),
  headerSmallFixed: () => ({
    styles: `
      @media ${media.tabletMax} {
        position: fixed;
        transition: top .2s ease-in-out;
      }
    `,
  }),
  headerSmallShow: () => ({
    styles: `
      @media ${media.tabletMax} {
        top: 0;
      }
    `,
  }),
};

export const AnimatedDiv = styled.div`
  transition: ${(props) => `${props.duration}ms ease-in-out`};
  transform: ${(props) => props.transform};
  opacity: ${(props) => props.initialOpacity};
  ${applyStyleModifiers(modifiers)};
`;

export const AnimatedMenuDiv = styled.header`
  width: 100%;
  ${position('fixed', '0', '', '', '0')};
  z-index: 1000;
  @media ${media.tabletMax} {
    position: absolute;
  }
  ${applyStyleModifiers(modifiers)};
`;
